(function () {
    if (typeof window === 'undefined') return;
    try {
        const originalFetch = window.fetch;
        window.fetch = function (resource, options) {
            if (typeof resource === 'string' && resource.includes('/api/') && resource.includes('/graphql.json')) {
                try {
                    if (options && options.method === 'POST' && options.body) {
                        const body = JSON.parse(options.body);
                        const country = (window.Shopify?.country || window.localization?.country?.iso_code || "").toUpperCase();
                        
                        if (country && country.length === 2 && typeof body?.query === 'string' && !body.query.includes('@inContext')) {
                            let q = body.query;
                            if (q.includes('query')) {
                                body.query = q.match(/query\s*\(([^)]+)\)/)
                                    ? q.replace(/query\s*\(([^)]+)\)/, 'query ($1, $country: CountryCode) @inContext(country: $country)')
                                    : q.replace(/query\s*{/, 'query ($country: CountryCode) @inContext(country: $country) {');
                                
                                body.variables = body.variables || {};
                                body.variables.country = country;
                                options.body = JSON.stringify(body);
                            }
                        }
                    }
                } catch (e) {
                }
            }
            return originalFetch.apply(this, arguments);
        };
    } catch (err) {
    }
})();
